import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogContent, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { addToCart, clearCart } from "../../store/ducks/app";
import { useDispatch, useSelector } from "react-redux";
import { OneFilter } from "../../models/app";


function ChangeCustomerModal({ 
  open, 
  setOpen,  
  setOpenChangeCustomer, 
  field, 
  subCustomers 
}: { 
  open: boolean; 
  setOpen: (value: boolean) => void; 
  setOpenChangeCustomer: (value: boolean) => void;
  field: string; 
  subCustomers: OneFilter[] 
}) {

    const dispatch = useDispatch();
   
    const theme = useTheme();

    const getHeight = () => {
      const { breakpoints } = theme;
      if (breakpoints.down('sm')) {
        return '280px'; // Height for xs and sm screens
      } else if (breakpoints.down('md')) {
        return '350px'; // Height for md screens
      } else {
        return '400px'; // Height for lg and xl screens (adjust as needed)
      }
    };

    const getFontSize = () => {
      const { breakpoints } = theme;
      if (breakpoints.down('sm')) {
        return '12px'; // Smaller font size for mobile screens
      } else {
        return '16px'; // Default font size for larger screens
      }
    };

  

const handleClearCart = ()=>{
  dispatch(clearCart());
  
  var filteredSubCustomers = subCustomers.filter(w => w.code === field);
  var canCheckOut = filteredSubCustomers.length > 0 ? !filteredSubCustomers[0].privacyblocked : false; 
  localStorage.setItem('CanCheckOut',  String(canCheckOut));
  localStorage.setItem('customeruserSystemId', field);
  setOpenChangeCustomer(false);
  window.location.reload();


}

return (
<Dialog
      open={open}
      onClose={() => setOpenChangeCustomer(false)}
      PaperProps={{
        sx: { borderRadius: "10px", padding: "10px", height: getHeight() },
      }}
    >
      <DialogContent sx={{ textAlign: "center" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ fontSize: "20px", marginBottom: "20px" }}>
              When Switching between SubCustomers, items in cart will be lost.
            </Typography>
            <Typography variant="h6" sx={{ fontSize: "20px" }}>
              Are you sure you want to proceed?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1} display={"flex"} style={{ justifyContent: "space-evenly" }}>
              <Grid item xs={5}>
                <Button
                  variant="contained"
                  color="success"
                  fullWidth
                 onClick={() => handleClearCart()}
                  sx={{ fontSize: getFontSize(), padding: "15px", height: "100%" }}
                >
                  Continue
                </Button>
              </Grid>
              <Grid item xs={5}>
                <Button variant="contained" color="error" fullWidth onClick={() => {setOpen(false); setOpenChangeCustomer(false);}} sx={{ fontSize: getFontSize(), padding: "15px", height: "100%" }}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
)


}

export default ChangeCustomerModal;
